function escapeHtml(value) {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function markdownToHtml(message) {
  const escaped = escapeHtml(message);
  const withLinks = escaped.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
  const withBold = withLinks.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
  const withItalic = withBold.replace(/\*([^*]+)\*/g, "<em>$1</em>");
  const paragraphs = withItalic
    .split(/\n{2,}/)
    .map((block) => `<p>${block.replace(/\n/g, "<br>")}</p>`);
  return paragraphs.join("");
}

export function renderAnnouncementMarkup(message) {
  const raw = String(message || "").trim();
  if (!raw) return "";
  if (/[<][^>]+[>]/.test(raw)) {
    return raw;
  }
  return markdownToHtml(raw);
}

export function isAnnouncementActive(banner = {}) {
  if (!banner?.enabled || !String(banner?.message || "").trim()) {
    return false;
  }

  const now = new Date();
  if (banner.startAt) {
    const startAt = new Date(banner.startAt);
    if (!Number.isNaN(startAt.getTime()) && now < startAt) {
      return false;
    }
  }

  if (banner.endAt) {
    const endAt = new Date(banner.endAt);
    if (!Number.isNaN(endAt.getTime()) && now > endAt) {
      return false;
    }
  }

  return true;
}

export function bannerClassForSeverity(severity = "info") {
  const normalized = String(severity || "").toLowerCase();
  if (normalized === "warning") return "announcement-banner--warning";
  if (normalized === "negative" || normalized === "error" || normalized === "danger") return "announcement-banner--negative";
  return "announcement-banner--info";
}
